"use client";

import React from "react";
import { HelpCircle } from "lucide-react";

interface FAQItemProps {
  question: string;
  answer: string;
}

export const BlogFAQ = ({ items }: { items: FAQItemProps[] }) => {
  return (
    <div className="my-20 pt-4 border-t border-white/[0.04]">
      <div className="flex items-center gap-3 mb-10">
        <div className="w-9 h-9 rounded-xl bg-brand-1/10 flex items-center justify-center text-brand-1">
          <HelpCircle className="w-4 h-4" />
        </div>
        <h3 className="text-2xl font-black text-white m-0! tracking-tight">
          Common Questions
        </h3>
      </div>

      <div className="grid gap-5">
        {items.map((item, index) => (
          <div
            key={index}
            className="p-6 md:p-7 rounded-2xl bg-white/[0.02] border border-white/[0.06] hover:border-brand-1/20 transition-colors group"
          >
            <h4 className="text-[16px] md:text-lg font-bold text-white mb-3 flex items-start gap-3 leading-snug group-hover:text-brand-1 transition-colors">
              <span className="text-brand-1/40 font-mono text-sm mt-0.5 shrink-0">
                Q.
              </span>
              {item.question}
            </h4>
            <div className="flex items-start gap-3">
              <span className="text-text-muted font-mono text-sm mt-0.5 opacity-0 shrink-0">
                A.
              </span>
              <p className="text-zinc-400 text-[15px] leading-[1.75] m-0!">
                {item.answer}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogFAQ;
